import { render, staticRenderFns } from "./controlbiologico2.vue?vue&type=template&id=59216a5c&scoped=true"
import script from "./controlbiologico2.vue?vue&type=script&lang=js"
export * from "./controlbiologico2.vue?vue&type=script&lang=js"
import style0 from "./controlbiologico2.vue?vue&type=style&index=0&id=59216a5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59216a5c",
  null
  
)

export default component.exports